import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
const links = [{
  name: 'Approach',
  href: '#approach'
}, {
  name: 'Included',
  href: '#included'
}, {
  name: 'Pricing',
  href: '#pricing'
}, {
  name: 'Timeline',
  href: '#timeline'
}, {
  name: 'Terms',
  href: '#terms'
}, {
  name: 'Sign',
  href: '#sign'
}];
export function FooterNav() {
  const [activeSection, setActiveSection] = useState('');
  useEffect(() => {
    const handleScroll = () => {
      const sections = links.map(link => link.href.substring(1));
      const scrollPosition = window.scrollY + window.innerHeight / 2;
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const {
            offsetTop,
            offsetHeight
          } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="fixed bottom-8 left-0 right-0 z-50 flex justify-center pointer-events-none px-4" data-id="element-35">
      <motion.div className="bg-gray-800/90 backdrop-blur-md rounded-full p-1.5 shadow-2xl pointer-events-auto flex items-center gap-1" initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 1,
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} data-id="element-36">
        {links.map(link => {
        const isActive = activeSection === link.href.substring(1);
        return <a key={link.name} href={link.href} className={`relative px-4 py-2 rounded-full text-sm font-semibold transition-colors duration-300 ${isActive ? 'text-gray-900' : 'text-gray-300 hover:text-white'}`} data-id="element-37">
              {isActive && <motion.div layoutId="activePill" className="absolute inset-0 bg-white rounded-full" transition={{
            type: 'spring',
            stiffness: 300,
            damping: 30
          }} data-id="element-38" />}
              <span className="relative z-10" data-id="element-39">{link.name}</span>
            </a>;
      })}
      </motion.div>
    </div>;
}